module.exports = __webpack_public_path__ + "static/img/nmxp.9838b79.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bc/nmxp.png
// module id = etc/
// module chunks = 0